var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewappointments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,452.267c0,14.114,11.486,25.6,25.6,25.6h460.8c14.114,0,25.6-11.486,25.6-25.6V136.533H0V452.267z M375.467,179.2 c0-4.719,3.823-8.533,8.533-8.533h51.2c4.71,0,8.533,3.814,8.533,8.533v51.2c0,4.719-3.823,8.533-8.533,8.533H384 c-4.71,0-8.533-3.814-8.533-8.533V179.2z M273.067,179.2c0-4.719,3.823-8.533,8.533-8.533h51.2c4.71,0,8.533,3.814,8.533,8.533 v51.2c0,4.719-3.823,8.533-8.533,8.533h-51.2c-4.71,0-8.533-3.814-8.533-8.533V179.2z M358.4,256 c51.755,0,93.867,42.112,93.867,93.867c0,51.755-42.112,93.867-93.867,93.867s-93.867-42.112-93.867-93.867 C264.533,298.112,306.645,256,358.4,256z M170.667,179.2c0-4.719,3.823-8.533,8.533-8.533h51.2c4.71,0,8.533,3.814,8.533,8.533 v51.2c0,4.719-3.823,8.533-8.533,8.533h-51.2c-4.71,0-8.533-3.814-8.533-8.533V179.2z M170.667,273.067 c0-4.719,3.823-8.533,8.533-8.533h51.2c4.71,0,8.533,3.814,8.533,8.533v51.2c0,4.719-3.823,8.533-8.533,8.533h-51.2 c-4.71,0-8.533-3.814-8.533-8.533V273.067z M170.667,366.933c0-4.719,3.823-8.533,8.533-8.533h51.2 c4.71,0,8.533,3.814,8.533,8.533v51.2c0,4.719-3.823,8.533-8.533,8.533h-51.2c-4.71,0-8.533-3.814-8.533-8.533V366.933z  M68.267,179.2c0-4.719,3.823-8.533,8.533-8.533H128c4.71,0,8.533,3.814,8.533,8.533v51.2c0,4.719-3.823,8.533-8.533,8.533H76.8 c-4.71,0-8.533-3.814-8.533-8.533V179.2z M68.267,273.067c0-4.719,3.823-8.533,8.533-8.533H128c4.71,0,8.533,3.814,8.533,8.533 v51.2c0,4.719-3.823,8.533-8.533,8.533H76.8c-4.71,0-8.533-3.814-8.533-8.533V273.067z M68.267,366.933 c0-4.719,3.823-8.533,8.533-8.533H128c4.71,0,8.533,3.814,8.533,8.533v51.2c0,4.719-3.823,8.533-8.533,8.533H76.8 c-4.71,0-8.533-3.814-8.533-8.533V366.933z",
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 281.6,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 187.733,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.733,
    y: 375.467,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.4,34.133H25.6c-14.114,0-25.6,11.486-25.6,25.6v59.733h512V59.733C512,45.619,500.514,34.133,486.4,34.133z",
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.133,
    y: 187.733,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.533,
    y: 187.733,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 375.467,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4,426.664c42.342,0,76.8-34.449,76.8-76.8c0-42.351-34.458-76.8-76.8-76.8s-76.8,34.449-76.8,76.8 C281.6,392.215,316.058,426.664,358.4,426.664z M309.7,352.364c3.337-3.328,8.73-3.328,12.066,0l26.778,26.778l45.423-68.139 c2.611-3.925,7.91-4.975,11.836-2.372c3.917,2.62,4.975,7.91,2.364,11.836l-51.2,76.8c-1.417,2.125-3.721,3.507-6.255,3.755 c-0.29,0.026-0.563,0.043-0.845,0.043c-2.253,0-4.429-0.887-6.033-2.5L309.7,364.431 C306.364,361.103,306.364,355.701,309.7,352.364z",
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.733,
    y: 281.6,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.733,
    y: 187.733,
    width: 34.133,
    height: 34.133,
    style: {
      fill: "rgb(0 153 153)"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewappointments);
export default __webpack_public_path__ + "static/media/newappointments.60b58eb90c324db5e9edf25a0cac0591.svg";
export { ForwardRef as ReactComponent };